import ArticleView from 'ui-article/axel-publication-content/js/ArticleView';
import SmartTables from 'ui-article/axel-publication-content/js/SmartTables';

export default class CabiArticleView extends ArticleView {
    constructor(source, config = {classNames: {}, selectors: {}, msg: {}}, templates) {
        super(source, config, templates);
        this.cabiWidgetIndex = 0;
    }

    addEventListeners() {
        super.addEventListeners();
        document.body.addEventListener('cabi-widget-loaded', e => this.enhanceCabiWidget(e));
        try {
            this.trackGetAccess();
        } catch (error) {
            console.error('Failed to track get access link', error);
        }
    }

    initEnhancers() {
        super.initEnhancers();

        try {
            this.copySearchQuery();
        } catch (error) {
            console.error('Article view - searchRxiv markup:', error);
        }
    }

    enhanceCabiWidget(e) {
        const tableHTML = e.target;
        const table = tableHTML.querySelector('.table');
        if (e.detail.name !== 'distribution-table' || !table) return;

        table.addEventListener('DOMSubtreeModified', () => {
            try {
                // add missing table id
                if (!table.id) {
                    table.id = tableHTML.parentNode.id + '-cabi-widget-' + this.cabiWidgetIndex;
                    this.cabiWidgetIndex++;
                }

                // reprocess tables data
                this.source.s.processorTitleSelector = this.source.s.processorTitleSelector + ', h2';
                this.source.data.figures = this.source.processors.figures(
                    document.querySelector(this.source.s.article)
                );
            } catch (error) {
                console.error('cabi-widget reprocess data', error);
            }

            // visually enhance table
            try {
                const newObj = this.source.data.figures.table.filter(obj => obj.id === table.id);
                new SmartTables(this.config.smartTables, newObj);
                newObj.forEach((obj, index) => this.enhanceMarkupButton(obj, index));
            } catch (error) {
                console.error('cabi-widget enhance table', error);
            }

            // update collateral tables pane
            try {
                const collateral = this.pill;
                const key = 'tables';
                if (collateral) {
                    const tablesTab = collateral.main.querySelector('#' + collateral.collateralTabIds[key]);
                    tablesTab.querySelector('.section--wrapper').remove();
                    collateral.buildFigureTab(key);
                }
            } catch (error) {
                console.error('cabi-widget update collateral', error);
            }

            // update figure viewer
            try {
                const fv = this.viewer;
                if (fv) {
                    fv.destroy();
                }
            } catch (error) {
                console.error('cabi-widget update figure viewer', error);
            }
        });
    }

    copySearchQuery() {
        const articleType = this.getArticle().dataset.type;
        if (articleType === 'search-string') {
            const articleSections = this.sectionNavbar.data.sections;
            const searchSection = articleSections.filter(h2 => h2.outerText === 'Search')[0]?.sectionParent;
            if (!searchSection) return;

            const heading = searchSection.querySelector('h2');

            const statusSelector = 'copy-query__status';
            const statusElement = document.createElement('span');
            statusElement.classList.add(statusSelector);
            statusElement.innerHTML =
                '<span class="copy-query__success"><i aria-hidden="true" class="icon-check_circle"></i><span>Copied to clipboard</span></span><span class="copy-query__failed"><i aria-hidden="true" class="icon-x_btnclose"></i><span>Copying failed</span></span>';

            const btn = document.createElement('button');
            btn.setAttribute('class', 'btn btn--primary copy-to-clipboard');
            btn.innerHTML = 'Copy to clipboard';
            btn.onclick = () =>
                navigator.clipboard.writeText(searchSection.childNodes.item(1).textContent).then(
                    () => {
                        const status = heading.querySelector('.' + statusSelector);
                        status.classList.add('success');
                        setTimeout(() => status.classList.remove('success'), 3000);
                    },
                    () => {
                        const status = heading.querySelector('.' + statusSelector);
                        status.classList.add('failed');
                        setTimeout(() => status.classList.remove('failed'), 3000);
                    }
                );
            heading?.append(btn, statusElement);
        }
    }

    trackGetAccess() {
        const buttons = document.querySelectorAll('a[href^="/doi/10.1079/cabicompendium"]');
        if (!buttons) return;
        const actionUrl = '/action/analytics';
        let hasTracked = false;

        const sendEvent = data => {
            if (navigator.sendBeacon) {
                navigator.sendBeacon(actionUrl, data);
            } else {
                var xhr = new XMLHttpRequest();
                xhr.open('POST', actionUrl, true);
                xhr.send(data);
            }
        };

        const getAccessTracking = () => {
            if (hasTracked) return; // prevent multiple sending of the same event when double-clicking
            hasTracked = true;

            const data = new FormData();
            const getAccessButton = document.getElementById('getAccessTechnicalFactsheets');
            data.append('DOI', getAccessButton.getAttribute('data-source-doi'));
            data.append('EventType', 'getAccessTechnicalFactsheets');
            sendEvent(data);
        };

        buttons.forEach(button => {
            button.addEventListener('click', getAccessTracking);
            button.addEventListener('keydown', function (event) {
                if (event.key === 'Enter') {
                    button.click();
                }
            });
        });
    }
}
